import { getExperiment } from '@eventbrite/statsig';
import { CheckoutDisqualifications, CheckoutType } from '../types';
import {
    DETACH_INTERESTS_FROM_USER_MENU,
    LISTING_TEST_AA_SSR_EXPERIMENT,
    LISTING_VIDEO_AUTOPLAY_EXPERIMENT,
    TIMED_ENTRY_SESSION_SELECTOR_EXPERIMENT,
} from './constants';

type ExperimentDef = {
    experimentName: string;
    param: string;
    defaultValue: string | boolean;
};

export const genericGetRawVariant = <T>(experiment: ExperimentDef): T =>
    getExperiment(
        experiment.experimentName,
        experiment.param,
        experiment.defaultValue,
    );

export const genericGetBooleanExperiment = (
    experiment: ExperimentDef,
): boolean => {
    const value = genericGetRawVariant<string | boolean>(experiment);
    return value === true || value === 'true';
};

export const isAutoplayVideoExperimentVariant = () =>
    genericGetRawVariant(LISTING_VIDEO_AUTOPLAY_EXPERIMENT);

export const isTestAAExperiment = () => {
    return genericGetBooleanExperiment(LISTING_TEST_AA_SSR_EXPERIMENT);
};

export const isDetachInterestsExperimentEnabled = () =>
    genericGetBooleanExperiment(DETACH_INTERESTS_FROM_USER_MENU);

export const isTESessionSelectorExperimentEnabled = (
    sessionsLength: number,
    isSalesEnded: boolean,
    isSoldOut: boolean,
    shouldShowCompactCheckout: boolean,
) => {
    if (
        sessionsLength < 5 ||
        isSalesEnded ||
        isSoldOut ||
        shouldShowCompactCheckout
    ) {
        return false;
    }

    return genericGetBooleanExperiment(TIMED_ENTRY_SESSION_SELECTOR_EXPERIMENT);
};

export const isListingTimedEntryCheckoutExperimentEnabled = (
    sessionsLength: number,
    seriesInfiniteCalendarSplitFF: boolean,
    parentEventId: string | undefined,
    childEventLength: number, //  Length of session for recurring events
) => {
    if (parentEventId) {
        if (sessionsLength || childEventLength) {
            return seriesInfiniteCalendarSplitFF;
        }
        return false;
    }
    return false;
};

export const getCheckoutType = (
    _isMultiTicketEnabled: boolean,
    _compactCheckoutDisqualifications: CheckoutDisqualifications,
) => {
    return CheckoutType.Compact;
};
